import React from 'react';
import styled from 'styled-components';
import { startCase } from 'lodash-es';

import { WorkflowDetailsNavContentProps } from './types';
import { formatWorkflowTypeString } from 'shared/utils/api/mappers/workflowMapper';

const StyledContainer = styled.div``;

const StyledValue = styled.span`
  word-wrap: break-word;

  display: block;
  margin-bottom: 0.25rem;
`;

const WorkflowDetailsNavContent = ({
  values: {type: workflowType, name},
}: WorkflowDetailsNavContentProps) => {

  
return (
  <StyledContainer>
    <StyledValue>{startCase(name)}</StyledValue>
    {workflowType && <StyledValue>{formatWorkflowTypeString(workflowType)}</StyledValue>}
  </StyledContainer>
);
}
export default WorkflowDetailsNavContent;
